// AuthContext.js
import React, { createContext, useReducer } from "react";

export const AuthContext = createContext();

const getLanguageFromSubdomain = () => {
  const sub = window.location.hostname.split(".")[0];
  return ["nl", "fr", "de"].includes(sub) ? sub : "en"; // default English
};

export const authReducer = (state, action) => {
  switch (action.type) {
    case "SET_LANGUAGE":
      return { ...state, language: action.payload };
    // ... keep your existing cases
    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, {
    // keep all your existing state
    language: getLanguageFromSubdomain(),
  });

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
